import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import {
  EpButtonType, EpButtonStyle, IEpGridModel,
  IEpGridColumn, IEpGridEditState, EpGridEditMode,
  IEpColumnNumericFormat, EpGridComponent
} from '@epicor/kinetic';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { Location } from '@angular/common';
import { QuickOrderLineModel } from '../../models/quick-order-line.model';
import { FieldAgentClient, ProductPrice } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { ProductType, QuantityType } from 'ep-bt-controls';
import { Router } from '@angular/router';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaTallyModel } from '../../models/epbt-fa-tally.model';
import { TallyEntryLineModel } from '../../models/tally-entry-line.model';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-order-tallied-product-line-negotiation',
  templateUrl: './epbt-fa-quick-order-tallied-product-line-negotiation.component.html',
  styleUrls: ['./epbt-fa-quick-order-tallied-product-line-negotiation.component.scss']
})
export class EpbtFaQuickOrderTalliedProductLineNegotiationComponent implements OnInit, AfterViewInit {

  selectedUnitSellPricePerPerId: number;
  perLabel = 'UOM';
  quickOrderLine: QuickOrderLineModel;
  EpButtonType = EpButtonType;
  EpButtonStyle = EpButtonStyle;
  talliedNegotiationForm: FormGroup;
  submitted = false;
  tallyGridModel: IEpGridModel;
  quickOrderTalliedLines: TallyEntryLineModel[];
  currency: string;
  quickOrderLines: any[] = [];
  quantityTallyLines: any[] = [];
  childProductsCount: number;
  tallyErrorFlag = true;
  numberFormat: IEpColumnNumericFormat = {
    max: 99999, min: 0, allowNegative: false, decimals: 0
  };
  disablePerDropDown = false;

  @ViewChild('tallyLengthTemplate', { static: true }) tallyLengthTemplate: TemplateRef<any>;
  @ViewChild('tallyParentTemplate', { static: true }) tallyParentTemplate: TemplateRef<any>;
  @ViewChild(EpGridComponent, { static: false }) tallyGrid: EpGridComponent;


  @Output() onSaveOrCancelClick = new EventEmitter<any>();

  constructor(public quickOrderService: EpbtFaQuickOrderService,
    private location: Location,
    private client: FieldAgentClient,
    private faService: EpbtFieldAgentService,
    private formBuilder: FormBuilder,
    private router: Router,
    private productService: EpbtFaProductService) { }

  ngOnInit() {

    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.currency = bistrackSettings.baseCurrency.symbol;
    });

    this.talliedNegotiationForm = this.formBuilder.group({
      quantity: ['', Validators.required],
      unitSellPrice: ['', Validators.required],
      discount1: [''],
      discount2: [''],
      lineNotes: [''],
      specialOrderProductDescription: ['']
    });

    if (!this.quickOrderService.quickOrderLine || !this.quickOrderService.quickOrderLine.Product) {
      this.location.back();
    }
    this.tallyGridModel = this.gettallyGridModel();
    if (!this.faService.webTrackUser) {
      this.faService.getWebTrackUser((webTrackUser: any) => {
        this.loadQuickOrderLineData((flag: any) => {
          this.setDataToUI(flag);
        });
      });
    } else {
      this.loadQuickOrderLineData((flag: any) => {
        this.setDataToUI(flag);
      });
    }
  }

  setDataToUI(flag) {
    console.log(flag);
    this.patchValues();
    this.quickOrderTalliedLines = this.quickOrderService.quickOrderLine.TallyEntryLines;
    this.tallyGridModel.data = this.quickOrderTalliedLines;
    if (this.quickOrderTalliedLines && this.quickOrderTalliedLines.filter(x => x.Quantity > 0).length > 0) {
      this.disablePerDropDown = false;
    } else {
      this.disablePerDropDown = true;
    }
  }

  ngAfterViewInit() {
    // this.tallyGridModel.columns[1].editOptions.numberFormat = this.numberFormat;
    if (this.quickOrderService.quickOrderLine.TallyEntryLines && this.quickOrderService.quickOrderLine.TallyEntryLines.length > 0) {
      const result = this.quickOrderService.quickOrderLine.TallyEntryLines.filter(x => x.Quantity > 0);
      if (result && result.length > 0) {
        this.tallyErrorFlag = false;
      }
    }
  }

  gettallyGridModel(): IEpGridModel {
    const model: IEpGridModel = {
      resizable: false,
      reorderable: true,
      groupable: false,
      filterable: false,
      editable: true,
      editOptions: {
        defaultEditable: true,
        editMode: EpGridEditMode.cell,
        updateOnChange: true,
        // validation on change of value
        onChangeValidate: (column: IEpGridColumn, newValue: any, originalValue: any, state: IEpGridEditState) => {
          if (column.field === 'Quantity' && newValue < 0) {
            return false;
          }
          if (column.field === 'Quantity' && (newValue % 1) > 0) {
            return false;
          }
          return true;
        },
        onEndEditValidate: (data: any) => {
          if (this.quickOrderTalliedLines && this.quickOrderTalliedLines.filter(x => x.Quantity > 0).length > 0) {
            this.disablePerDropDown = false;
          } else {
            this.disablePerDropDown = true;
          }
          return true;
        }
      },
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      data: this.quickOrderTalliedLines,
      columns: [
        { field: 'Length', title: 'Length', width: 100, hidden: false, editable: false, cellTemplate: this.tallyLengthTemplate },
        { field: 'Quantity', title: 'Quantity', width: 100, hidden: false, class: 'color-blue', editable: true, editor: 'numeric' },
        { field: 'SellPrice', title: 'Selling Price', width: 100, hidden: !this.quickOrderService.isParentTally(), editable: false, cellTemplate: this.tallyParentTemplate },
      ]
    };
    return model;
  }

  /// <summary>
  /// Update UI controls from DB
  /// or QuickOrder.Line QuickOrderLine object - declared in ProductInfoPage class
  /// </summary>
  loadQuickOrderLineData(subscribe: (flag: any) => void) {
    this.client.loadProductPers(this.quickOrderService.quickOrderLine.Product).subscribe(resultProduct => {
      this.quickOrderService.quickOrderLine.Product = resultProduct;

      if (this.quickOrderService.quickOrderLine && this.quickOrderService.quickOrderLine.Per && this.quickOrderService.quickOrderLine.Per.perId > 0) {
        this.selectedUnitSellPricePerPerId = this.quickOrderService.quickOrderLine.Per.perId;
      } else {
        // Need to add this condition as well
        // changing the below condition because we are not updating the selected customer to WebtrackUser, so checking directly in QuickOrderModel.customer
        // if (this.faService.webTrackUser && this.faService.webTrackUser.customer.useEachPricing &&
        //   (this.quickOrderService.quickOrderLine.Product.productType == ProductType.TimberTallied || this.quickOrderService.quickOrderLine.Product.productType == ProductType.TimberSheetMaterial)) {
        if (this.quickOrderService.quickOrder.customer && this.quickOrderService.quickOrder.customer.useEachPricing &&
          (this.quickOrderService.quickOrderLine.Product.productType == ProductType.TimberTallied || this.quickOrderService.quickOrderLine.Product.productType == ProductType.TimberSheetMaterial)) {
          const eaches = this.quickOrderService.quickOrderLine.Product.sellPricePers.filter(sellPer => sellPer.perId == 1); // Each is always 1
          if (eaches && eaches.length > 0) {
            this.selectedUnitSellPricePerPerId = eaches[0].perId;
          } else {
            this.selectedUnitSellPricePerPerId = this.quickOrderService.quickOrderLine.Product.sellPer.perId;
          }
        } else {
          this.selectedUnitSellPricePerPerId = this.quickOrderService.quickOrderLine.Product.sellPer.perId;
        }
      }
      this.patchValues();
      this.recalculateLineTotals(false, false, false, (flag: boolean) => {
        subscribe(true);
      });
    });
  }

  /// <summary>
  /// Recalculate order line totals
  /// </summary>
  /// <param name="getTallyFromUI"></param>
  /// <param name="ignoreManualPrice"></param>
  recalculateLineTotals(getTallyFromUI: boolean = true, ignoreManualPrice: boolean = false, includeDiscounts: boolean = false, subscribe: (flag: boolean) => void) {
    if (!this.productService.shouldTallyProduct(this.quickOrderService.quickOrderLine.Product.tallyLengths)) {
      subscribe(true);
      return;
    }

    if (getTallyFromUI) {
      this.getTallyFromUI(false);
    }

    if (!this.quickOrderService.quickOrderLine.Tally || !this.quickOrderService.quickOrderLine.Tally.tallyString) {
      this.quickOrderService.quickOrderLine.TotalSellPrice = 0;
      this.quickOrderService.quickOrderLine.Quantity = 0;
      // this.lblInfo.Text = "* Please enter tally information.";
      subscribe(true);
      return;
    } else {
      // this.lblInfo.Text = "";
    }

    this.quickOrderService.quickOrderLine.QuantityTally = this.quickOrderService.quickOrderLine.Tally.tallyString;

    // Update tally totals(volume,length, area)
    this.quickOrderService.updateLineTotals((flag: boolean) => {
      // Set to product inputPer for now,
      this.quickOrderService.quickOrderLine.InputPer = this.quickOrderService.quickOrderLine.Product.inputPer != null ?
        this.quickOrderService.quickOrderLine.Product.inputPer : this.quickOrderService.quickOrderLine.Product.inputPers[0];

      let discount1 = 0.0;
      let discount2 = 0.0;

      if (!includeDiscounts) {
        discount1 = this.quickOrderService.quickOrderLine.Discount1;
        discount2 = this.quickOrderService.quickOrderLine.Discount2;
        this.quickOrderService.quickOrderLine.Discount1 = 0.0;
        this.quickOrderService.quickOrderLine.Discount2 = 0.0;
      }

      // update line price:
      let linePrice = new ProductPrice();
      if (ignoreManualPrice || !this.quickOrderService.quickOrderLine.IsManuallyPriced) {
        this.quickOrderService.getOrderLinePrice(false, null, (result: any) => {
          linePrice = result;
          if (linePrice) {
            if (!this.quickOrderService.quickOrderLine.IsManuallyPriced) {
              this.quickOrderService.quickOrderLine.UnitSellPrice = linePrice.unitSellPrice;
            }
            this.quickOrderService.quickOrderLine.TotalSellPrice = this.quickOrderService.quickOrderLine.Tally.tallyString == '' ? 0 : linePrice.totalSellPrice;
            // this.UnitSellPrice.Text = $"{linePrice.UnitSellPrice:N2}";
            this.talliedNegotiationForm.controls['unitSellPrice'].setValue(linePrice.unitSellPrice);
            subscribe(true);
          }
        });
      } else {
        this.quickOrderService.getOrderLinePrice(true, null, (result: any) => {
          linePrice = result;
          if (linePrice) {
            if (!this.quickOrderService.quickOrderLine.IsManuallyPriced) {
              this.quickOrderService.quickOrderLine.UnitSellPrice = linePrice.unitSellPrice;
            }
            this.quickOrderService.quickOrderLine.TotalSellPrice = this.quickOrderService.quickOrderLine.Tally.tallyString == '' ? 0 : linePrice.totalSellPrice;
            // this.UnitSellPrice.Text = $"{linePrice.UnitSellPrice:N2}";
            this.talliedNegotiationForm.controls['unitSellPrice'].setValue(linePrice.unitSellPrice);
            subscribe(true);
          }
        });
      }

      if (!includeDiscounts) {
        this.quickOrderService.quickOrderLine.Discount1 = discount1;
        this.quickOrderService.quickOrderLine.Discount2 = discount2;
      }

      this.quickOrderService.quickOrderLine.Adding = false;

    });
  }

  getTallyFromUI(includeDiscounts: boolean = false) {
    this.quickOrderService.quickOrderLine.Tally = new EpbtFaTallyModel();
    const lengths = this.quickOrderService.quickOrderLine.Product.tallyLengths.split(',');
    for (let i = 0; i < this.quickOrderTalliedLines.length; i++) {
      const qty = this.quickOrderTalliedLines[i].Quantity;
      this.quickOrderService.quickOrderLine.TallyEntryLines[i].Quantity = qty;
      this.quickOrderService.quickOrderLine.Tally.add(qty.toString(), lengths[i]);
    }

    if (includeDiscounts && !this.quickOrderService.isParentTally()) {
      this.quickOrderService.quickOrderLine.Discount1 = this.talliedNegotiationForm.controls['discount1'].value ? this.talliedNegotiationForm.controls['discount1'].value : 0;
      this.quickOrderService.quickOrderLine.Discount2 = this.talliedNegotiationForm.controls['discount2'].value ? this.talliedNegotiationForm.controls['discount2'].value : 0;
      this.quickOrderService.quickOrderLine.LineNotes = this.talliedNegotiationForm.controls['lineNotes'].value;
      // this.talliedNegotiationForm.controls["unitSellPrice"].value
    }
  }

  patchValues() {
    this.talliedNegotiationForm.patchValue({
      quantity: this.quickOrderService.quickOrderLine.Quantity,
      unitSellPrice: this.quickOrderService.quickOrderLine.UnitSellPrice,
      discount1: this.quickOrderService.quickOrderLine.Discount1 ? this.quickOrderService.quickOrderLine.Discount1 : 0,
      discount2: this.quickOrderService.quickOrderLine.Discount2 ? this.quickOrderService.quickOrderLine.Discount2 : 0,
      lineNotes: this.quickOrderService.quickOrderLine.LineNotes
    });
  }

  // This will be use in html code for validation
  get frmFields() { return this.talliedNegotiationForm.controls; }

  onTalliedNegotiationSave() {
    this.submitted = true;
    if (this.talliedNegotiationForm.invalid || !this.checkMaxQuantityLimit() || !this.quickOrderService.checkMaxQuantityLimitForRelatedProducts()) {
      return;
    } else {

      this.getTallyFromUI(true);
      this.recalculateLineTotals(false, false, true, (flag: boolean) => {
        if (this.quickOrderService.isParentTally()) {
          this.quickOrderLine = this.quickOrderService.quickOrderLine;
          this.quantityTallyLines = this.quickOrderService.quickOrderLine.TallyEntryLines.filter(x => x.Quantity > 0);
          this.quickOrderLines = [];
          this.childProductsCount = 0;
          this.createChildProducts((flag: boolean) => {
            this.router.navigate(['/home/quickorder']);
          });
        } else {
          const index = this.quickOrderService.quickOrder.Lines.findIndex(x => x.LineNumber == this.quickOrderService.quickOrderLine.LineNumber);
          if (index != -1) {
            this.quickOrderService.quickOrder.Lines[index] = this.quickOrderService.quickOrderLine;
          } else {
            this.quickOrderService.quickOrder.LineAdd(this.quickOrderService.quickOrderLine);
          }

          if (this.quickOrderService.selectedRelatedproduct && this.quickOrderService.selectedRelatedproduct.length > 0) {
            const count = 0;
            this.quickOrderService.createRelatedProductOrderLine(count, (flag: boolean) => {
            });
          } else {
            this.router.navigate(['/home/quickorder']);
          }
        }
      });
    }
  }

  onSaveOrCancelSubmit(flag: boolean) {
    // True - Save clicked False - Cancel Clicked
    if (flag) {
      this.onTalliedNegotiationSaveForNewOrder((flag: boolean) => {
        // this.onSaveOrCancelClick.emit(flag);
      });
    } else {
      this.onSaveOrCancelClick.emit(true);
    }
  }

  onTalliedNegotiationSaveForNewOrder(subscribe: (flag: any) => void) {
    this.submitted = true;
    if (this.talliedNegotiationForm.invalid || !this.checkMaxQuantityLimit()) {
      this.onSaveOrCancelClick.emit(true);
    } else {

      this.getTallyFromUI(true);
      this.recalculateLineTotals(false, false, true, (flag: boolean) => {
        if (this.quickOrderService.isParentTally()) {
          this.quickOrderLine = this.quickOrderService.quickOrderLine;
          this.quantityTallyLines = this.quickOrderService.quickOrderLine.TallyEntryLines.filter(x => x.Quantity > 0);
          this.quickOrderLines = [];
          this.childProductsCount = 0;
          this.createChildProducts((flag: boolean) => {
            // subscribe(true);
            this.onSaveOrCancelClick.emit(true);
          });
        } else {
          const index = this.quickOrderService.quickOrder.Lines.findIndex(x => x.LineNumber == this.quickOrderService.quickOrderLine.LineNumber);
          if (index != -1) {
            this.quickOrderService.quickOrder.Lines[index] = this.quickOrderService.quickOrderLine;
          } else {
            this.quickOrderService.quickOrder.LineAdd(this.quickOrderService.quickOrderLine);
          }
          // if (!isPopup)
          //   this.router.navigate(['/home/quickorder']);
          this.onSaveOrCancelClick.emit(true);
        }
      });
    }
  }

  checkMaxQuantityLimit(): boolean {
    let flag = true;
    const regexp = new RegExp('^[0-9]{1,6}(\\.[0-9]+)?$');
    this.quickOrderService.quickOrderLine.TallyEntryLines.forEach(element => {
      if (!regexp.test(element.Quantity.toString())) {
        flag = false;
      }
    });
    return flag;
  }

  createChildProducts(subscribe: (flag: boolean) => void) {
    if (this.quickOrderLine.Product.childProducts.length > 0) {
      const item = this.quantityTallyLines[this.childProductsCount];
      const results = this.quickOrderLine.Product.childProducts.filter(x => x.productId == item.ProductID);
      const product = results[0];
      if (product != null) {
        this.quickOrderService.createQuickOrderLine(product, QuantityType.Per, item.Quantity, (quickOrderLine: any) => {
          console.log('ChildProductsCount=', this.childProductsCount, quickOrderLine);
          const index = this.quickOrderLines.indexOf(x => x.productId == product.productId);
          if (index <= 0) {
            this.childProductsCount = this.childProductsCount + 1;
            // quickOrderLine.Product.tallyLengths = item.Quantity + ",";
            this.quickOrderLines.push(quickOrderLine);
            this.quickOrderService.quickOrder.LineAdd(quickOrderLine, false);
          }
          if (this.quickOrderLines.length == this.quantityTallyLines.length) {
            // subscribe(true);
            if (!this.quickOrderService.isNewOrder) {
              this.router.navigate(['/home/quickorder']);
            } else {
              this.onSaveOrCancelClick.emit(true);
            }
          } else {
            this.createChildProducts((flag: boolean) => {
            });
          }
        });
      } else {

      }
    } else {
      if (!this.quickOrderService.isNewOrder) {
        this.router.navigate(['/home/quickorder']);
      } else {
        this.onSaveOrCancelClick.emit(true);
      }
    }




    // if (this.quickOrderLine.Product.childProducts.length > 0) {
    //   // If Product has childs,
    //   // we will delete parent product from QO and add order line for each
    //   // child products ( if quantity has been specified by user)
    //   if (this.others.length != this.quantityTallyLines.length) {
    //     for (var i = 0; i < this.quantityTallyLines.length; i++) {
    //       var item = this.quantityTallyLines[i - 1];
    //       var results = this.quickOrderLine.Product.childProducts.filter(x => x.productId == item.ProductID);
    //       var product = results[0];
    //       if (product != null) {
    //         var index = this.others.indexOf(x => x.productId == product.productId);
    //         if (index <= 0) {
    //           this.quickOrderService.createQuickOrderLine(product, QuantityType.Per, item.Quantity, (quickOrderLine: any) => {
    //             console.log("I=", i, quickOrderLine);
    //             var index = this.others.indexOf(x => x.productId == product.productId);
    //             if (index <= 0) {
    //               this.others.push(quickOrderLine);
    //               this.quickOrderService.quickOrder.LineAdd(quickOrderLine, false);
    //             }
    //             if (this.others.length == this.quantityTallyLines.length) {
    //               // subscribe(true);
    //               this.router.navigate(['/home/quickorder']);
    //             }
    //             else {
    //               this.createChildProducts((flag: boolean) => {
    //               });
    //             }
    //           });
    //         }
    //       }
    //     }
    //   }
    //   else {
    //     // subscribe(true);
    //     this.router.navigate(['/home/quickorder']);
    //   }


    //   // var others: any[] = [];

    //   // for (var i = 0; i < this.quickOrderService.quickOrderLine.TallyEntryLines.length; i++) {
    //   //   var item = this.quickOrderService.quickOrderLine.TallyEntryLines[i];
    //   //   var length = this.quickOrderService.quickOrderLine.TallyEntryLines.filter(x => x.Quantity > 0).length;
    //   //   if (item.Quantity > 0) {
    //   //     var results = this.quickOrderService.quickOrderLine.Product.childProducts.filter(x => x.productId == item.ProductID);
    //   //     var product = results[0];
    //   //     if (product != null) {
    //   //       var index = others.indexOf(x => x.productId == product.productId);
    //   //       if (index <= 0) {
    //   //         this.quickOrderService.createQuickOrderLine(product, QuantityType.Per, item.Quantity, (quickOrderLine: any) => {
    //   //           // this.quickOrderService.quickOrder.LineAdd(quickOrderLine, false);
    //   //           others.push(quickOrderLine);

    //   //           this.quickOrderService.quickOrder.LineAdd(quickOrderLine, false);

    //   //           if (others.length == length) {
    //   //             subscribe(true);
    //   //           }
    //   //           else
    //   //           {
    //   //             this.createChildProducts((flag: boolean) => {
    //   //             });
    //   //           }
    //   //         });
    //   //       }
    //   //     }
    //   // }

    //   // this.quickOrderLine.TallyEntryLines.forEach(item => {
    //   // if (item.Quantity > 0) {
    //   //   var results = this.quickOrderLine.Product.childProducts.filter(x => x.productId == item.ProductID);
    //   //   var product = results[0];
    //   //   if (product != null) {
    //   //     var index = others.indexOf(x => x.productId == product.productId);
    //   //     if (index <= 0) {
    //   //       this.quickOrderService.createQuickOrderLine(product, QuantityType.Per, item.Quantity, (quickOrderLine: any) => {
    //   //         // this.quickOrderService.quickOrder.LineAdd(quickOrderLine, false);
    //   //         others.push(quickOrderLine);
    //   //       });
    //   //     }
    //   //   }
    //   // }
    //   // });
    // }
    // else {
    //   // subscribe(true);
    //   this.router.navigate(['/home/quickorder']);
    // }
  }

  onUnitSellPriceChange(selectedValue: any): void {
    if (selectedValue) {
      this.getTallyFromUI(false);
      this.selectedUnitSellPricePerPerId = selectedValue.perId;
      if (!this.quickOrderService.quickOrderLine.Tally.tallyString) {
        this.selectedUnitSellPricePerPerId = this.quickOrderService.quickOrderLine.Per.perId;
      } else {
        this.quickOrderService.quickOrderLine.OldPerId = this.quickOrderService.quickOrderLine.Per.perId;
        const eaches = this.quickOrderService.quickOrderLine.Product.sellPricePers.filter(p => p.perId == selectedValue.perId);
        if (eaches && eaches.length > 0) { this.quickOrderService.quickOrderLine.Per = eaches[0]; }

        this.recalculateLineTotals(true, true, false, (flag: boolean) => {
          // CreateChildProducts();
        });

      }
    }
  }

  onBlur() {
    // console.log('Blurred:-', this.talliedNegotiationForm.controls["unitSellPrice"].value);
    this.tallyErrorFlag = false;
    this.quickOrderService.quickOrderLine.UnitSellPrice = this.talliedNegotiationForm.controls['unitSellPrice'].value;
    this.quickOrderService.quickOrderLine.IsManuallyPriced = true;
    this.recalculateLineTotals(true, false, false, (flag: boolean) => {
      // CreateChildProducts();
    });
  }

  cancelTalliedNegotiationClicked() {
    // this.router.navigate(['/home/customer/details', this.customerId]);
    // this.location.back();
    this.router.navigate(['/home/quickorder']);
  }


}

